"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = void 0;
// import CryptoJS from "crypto-js";
var CryptoJS = require("crypto-js");
// import CryptoJS = require("crypto-js")
// import CryptoJS = require("crypto-js")
// import { APP_SPLIT_KEY, APP_SPLIT_SECRET } from "@/config/constVariables";
// const KEY = CryptoJS.enc.Utf8.parse(APP_SPLIT_KEY);
// const IV = CryptoJS.enc.Utf8.parse(APP_SPLIT_SECRET);
function encrypt(word, keyString, ivString) {
    //密钥
    var key;
    //密钥偏移量
    var iv;
    var keyStr = CryptoJS.enc.Utf8.parse(keyString);
    var ivStr = CryptoJS.enc.Utf8.parse(ivString);
    if (keyStr) {
        key = keyStr;
        iv = ivStr;
    }
    // console.log('加密字段===>>>>word',word);
    // console.log('加密字段===>>>>keyString',keyString);
    // console.log('加密字段===>>>>ivString',ivString);
    //密文
    var encrypted = CryptoJS.AES.encrypt(word, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    // console.log(
    //   "aes加密---->>>>",
    //   CryptoJS.enc.Base64url.stringify(encrypted.ciphertext)
    // );
    return CryptoJS.enc.Base64url.stringify(encrypted.ciphertext);
}
exports.encrypt = encrypt;
function decrypt(word, keyStr, ivStr) {
    var key;
    var iv;
    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }
    var base64 = CryptoJS.enc.Base64.parse(word);
    var src = CryptoJS.enc.Base64.stringify(base64);
    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedStr.toString());
}
exports.decrypt = decrypt;
